
import React from 'react';
import { useCustomerEditForm } from './hooks/useCustomerEditForm';
import { Button } from '@/components/ui/button';
import { Loader2, ArrowLeft } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CustomerInfoTab from './edit-form/CustomerInfoTab';
import CustomerOrdersTab from './edit-form/CustomerOrdersTab';

interface CustomerEditFormProps {
  customerId: string;
  onBack: () => void;
  onSuccess: () => void;
  shopId?: string;
}

const CustomerEditForm = ({ customerId, onBack, onSuccess, shopId }: CustomerEditFormProps) => {
  const {
    name, setName,
    email, setEmail,
    phone, setPhone,
    country, setCountry,
    region, setRegion,
    municipality, setMunicipality,
    address, setAddress,
    loading,
    saving,
    errors,
    handleSave,
    customer,
    orders,
    totalSpent,
    organizationId
  } = useCustomerEditForm(customerId, onSuccess, shopId);

  console.log("CustomerEditForm rendered with shopId:", shopId, "organizationId:", organizationId);
  
  // Is this a new customer?
  const isNewCustomer = customerId === 'new';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSave();
  };

  // Show loading state
  if (loading && !isNewCustomer) {
    return (
      <div className="flex justify-center items-center h-96">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-6 bg-white dark:bg-gray-900">
      <div className="flex items-center mb-6">
        <Button onClick={onBack} variant="ghost" className="mr-4">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Retour
        </Button>
        <h1 className="text-xl font-semibold">{isNewCustomer ? 'Nouveau Client' : 'Modifier le Client'}</h1>
      </div>

      <Tabs defaultValue="info" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="info">Informations</TabsTrigger>
          {!isNewCustomer && <TabsTrigger value="orders">Commandes</TabsTrigger>}
        </TabsList>

        <TabsContent value="info">
          <CustomerInfoTab
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            phone={phone}
            setPhone={setPhone}
            address={address}
            setAddress={setAddress}
            country={country}
            setCountry={setCountry}
            region={region}
            setRegion={setRegion}
            municipality={municipality}
            setMunicipality={setMunicipality}
            errors={errors}
            saving={saving}
            onBack={onBack}
            handleSubmit={handleSubmit}
          />
        </TabsContent>

        {!isNewCustomer && (
          <TabsContent value="orders">
            <CustomerOrdersTab 
              orders={orders} 
              totalSpent={totalSpent} 
              organizationId={organizationId}
            />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default CustomerEditForm;
